import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import music1 from '../../../assets/images/music-1.png'
import music2 from '../../../assets/images/music-2.png'
import music3 from '../../../assets/images/music-3.png'
import music4 from '../../../assets/images/music-4.png'
import music5 from '../../../assets/images/music-5.png'

export default function LocalMusic() {
    const place = useSelector(state => state.place);

    const musicList = [
        { img: music1, title: "Rock", category: "Rock" },
        { img: music2, title: "Blues", category: "Blues" },
        { img: music3, title: "Jazz", category: "Jazz" },
        { img: music4, title: "Country", category: "Country" },
        { img: music5, title: "Concerts", category: "Concerts" },
    ];

    return (
        <section className="section-equal-padding owl-nav-left local-music-section">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12 col-sm-12 col-md-12 col-lg-7">
                        <div
                            className="section-top-heading mb-3 mb-md-5"
                            uk-scrollspy="cls: uk-animation-slide-bottom; delay: 400; repeat: false"
                        >
                            <h2 className="mb-2 text-black">Local Music</h2>
                            <p>Enjoy the music of local artist</p>
                        </div>
                    </div>
                </div>

                <Swiper
                    modules={[Navigation, Autoplay]}
                    navigation
                    autoplay={{
                        delay: 3000,
                        disableOnInteraction: false,
                    }}
                    spaceBetween={20}
                    slidesPerView={3}
                    breakpoints={{
                        0: { slidesPerView: 1 },
                        576: { slidesPerView: 2 },
                        992: { slidesPerView: 3 },
                        1400: { slidesPerView: 4 },
                    }}
                    className="Owl3card pb-70"
                >
                    {musicList.map((item, index) => {
                        const safePlace =
                            place && place.toLowerCase() !== item.category.toLowerCase()
                                ? place
                                : "";

                        const url = safePlace
                            ? `/things-to-do/${item.category}/${encodeURIComponent(safePlace)}`
                            : `/things-to-do/${item.category}`;

                        return (
                            <SwiperSlide key={index}>
                                <div
                                    className="card-item p-0"
                                    uk-scrollspy="cls: uk-animation-slide-bottom; delay: 400; repeat: false"
                                >
                                    <div className="exp-box exp-music-box d-flex align-items-center gap-3">
                                        <figure>
                                            <img src={item?.img} className="img-fluid" alt="music" />
                                        </figure>
                                        <div className="exp-description">
                                            <h3>{item?.title}</h3>
                                            <Link to={url}>
                                                Explore More <i className="fa-solid fa-arrow-right"></i>
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </SwiperSlide>
                        )
                    })}
                </Swiper>
            </div>
        </section>
    );
}
